export const SET_SELECTED_SHIPMENT = 'SET_SELECTED_SHIPMENT'
export const REMOVE_SELECTED_SHIPMENT = 'REMOVE_SELECTED_SHIPMENT'
export const SET_IS_SELECTING_SHIPMENT = 'SET_IS_SELECTING_SHIPMENT'

export const REMOVE_SHIPMENTS_CONTEXT_ERRORS = 'REMOVE_SHIPMENTS_CONTEXT_ERRORS'
export const SET_SHIPMENTS_CONTEXT_ERRORS = 'SET_SHIPMENTS_CONTEXT_ERRORS'

export const SET_IS_LOADING_PROVIDERS = 'SET_IS_LOADING_PROVIDERS'
export const SET_POSSIBLE_PROVIDERS = 'SET_POSSIBLE_PROVIDERS'

export const SET_IS_SETTING_PROVIDER = 'SET_IS_SETTING_PROVIDER'
export const UPDATE_SELECTED_SHIPMENT = 'UPDATE_SELECTED_SHIPMENT'

export const SET_PROVIDERS_MENU_FILTER = 'SET_PROVIDERS_MENU_FILTER'
export const REMOVE_PROVIDERS_MENU_FILTER = 'REMOVE_PROVIDERS_MENU_FILTER'

export const SET_IS_SETTING_CUSTOM_PROVIDER = 'SET_IS_SETTING_CUSTOM_PROVIDER'

export const SET_SHIPMENTS_LABELS = 'SET_SHIPMENTS_LABELS'

export const SET_RESET_STATE = 'SET_RESET_STATE'

export const SET_GOODS_VALUE_BY_DAY_FETCHING = 'SET_GOODS_VALUE_BY_DAY_FETCHING'
export const GOODS_VALUE_BY_DAY_UPDATED = 'GOODS_VALUE_BY_DAY_UPDATED'
export const SET_GOODS_VALUE_ERROR = 'SET_GOODS_VALUE_ERROR'
export const REMOVE_GOODS_VALUE_ERROR = 'REMOVE_GOODS_VALUE_ERROR'
